import VueGtag, { trackRouter } from 'vue-gtag-next'

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()
  nuxtApp.vueApp.use(VueGtag, {
    isEnabled: false,
    property: {
      id: config.public.gaid,
    },
  } as any)
  trackRouter(useRouter(), { skipSamePath: true })
})
